import moment from "moment";

const timeoffLedgersBulkUploadColumns = [
  {
    field: "",
    key: "numbering",
    title: "#",
    width: 10,
    align: "center",
    renderBodyCell: ({ rowIndex }) => {
      return ++rowIndex;
    },
  },

  {
    field: "Type",
    key: "type",
    title: "Type",
    headerAlign: "left",
    align: "left",
    renderBodyCell: ({ row }) => row.Type.split(/(?=[A-Z])/).join(" "),
  },
  {
    field: "TimeoffJournal",
    key: "TimeoffJournal",
    title: "Timeoff Journal",
    headerAlign: "left",
    align: "left",
  },
  {
    field: "TimeoffType",
    key: "leavetypeid",
    title: "Timeoff Type",
    headerAlign: "left",
    align: "left",
  },

  {
    field: "EmployeeNo",
    key: "EmployeeNo",
    title: "Employee No",
    headerAlign: "left",
    align: "left",
  },

  {
    field: "Days",
    key: "days",
    title: "Days",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "StartDate",
    key: "StartDate",
    title: "Start Date",
    headerAlign: "center",
    align: "center",
    renderBodyCell: ({ row }) =>
      moment(row.StartDate).format("DD/MM/YYYY"),
  },
  {
    field: "EndDate",
    key: "EndDate",
    title: "End Date",
    headerAlign: "center",
    align: "center",
    // renderBodyCell: ({ row }) => moment(row.EndDate).format("DD/MM/YYYY"),
  },
 
];

export default timeoffLedgersBulkUploadColumns;
